'use client'

import { Form, InputGroup, Button } from 'react-bootstrap'
import Link from 'next/link'
import { useState, useRef } from 'react'
import api from '@/shared/api'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import ReCAPTCHA from 'react-google-recaptcha'
import { SITE_KEY_RECAPTCHA } from '@/shared/constants/linksApi'

export const FormRegister = ({ textButton, submitForm, setRecaptchaToken }) => {
    const [checked, setChecked] = useState(false)
    const [customerType, setCustomerType] = useState('1')
    const passwordRef = useRef(['', ''])
    const emailRef = useRef('')
    const [showPassword, setShowPassword] = useState([false, false])

    const recaptchaRef = useRef(null);

     const validateEmail = (value) => {
        if (value.trim() !== value) {
            TOAST_ERROR('Email не должен начинаться или заканчиваться пробелом');
            return false;
        }
        // базовая email-проверка
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            TOAST_ERROR('Email не корректен');
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault()

        const emailValue = emailRef.current;
        console.log(emailRef.current)
        if (!validateEmail(emailValue)) return;

        if (passwordRef.current[0] !== passwordRef.current[1]) {
            TOAST_ERROR('Пароли не совпадают')
            return
        }
            
        await submitForm(e, checked)

        recaptchaRef.current.reset();
    }

    const handleChangeCustomerType = (e) => {
        setCustomerType(e.target.value)
    }

    const handleUpload = async (e) => {
        const file = e.target.files[0]
        const form = new FormData()
        form.append('file', file)
        try {
            const response = await api.post(
                'index.php?route=tool/upload&inferno=13',
                form
            )
            alert(response.data.success)
        } catch (error) {
            // console.log(error)
        }
    }

    const togglePasswordVisibility = (index) => {
        setShowPassword((prev) =>
            index === 0 ? [!prev[0], prev[1]] : [prev[0], !prev[1]]
        )
    }

    return (
        <Form className="FormAuth"  onSubmit={handleSubmit}>
            <Form.Select
                onChange={handleChangeCustomerType}
                name="customer_type"
                defaultValue=""
                className='customer-select'
                required
            >
                <option value="" disabled hidden>
                    Выберите категорию для регистрации
                </option>
                <option value="1">Частное лицо</option>
                <option value="2">Косметолог/Врач/Медицинский центр/Салон красоты</option>
            </Form.Select>

            {customerType === '2' && (
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>
                        Загрузите Диплом косметолога или карточку Салона
                        красоты, Клиники
                    </Form.Label>
                    <Form.Control
                        type="file"
                        onChange={handleUpload}
                        name="sertificat"
                    />
                </Form.Group>
            )}

            <InputGroup className={'input-control'}>
                <label>Имя</label>
                <Form.Control
                    required={true}
                    type={'text'}
                    placeholder={'Введите Имя'}
                    name={'name'}
                />
            </InputGroup>
            <InputGroup className={'input-control'}>
                <label>Фамилия</label>
                <Form.Control
                    required={true}
                    type={'text'}
                    placeholder={'Введите Фамилию'}
                    name={'surname'}
                />
            </InputGroup>
            <InputGroup className={'input-control'}>
                <label>Телефон</label>
                <Form.Control
                    required={true}
                    type={'text'}
                    placeholder={'Введите Телефон'}
                    name={'phone'}
                />
            </InputGroup>

            <InputGroup hasValidation className={'input-control'}>
                <label>E-Mail</label>
                <Form.Control 
                    required={true}
                    type={'text'}
                    placeholder={'Введите E-Mail'}
                    name={'email'}
                    onChange={(e) => {
                        emailRef.current = e.target.value
                    }}
                />
            </InputGroup>
            <InputGroup className={'input-control input-control-password'}>
                <label>Пароль</label>
                <Form.Control
                    required={true}
                    type={showPassword[0] ? 'text' : 'password'}
                    placeholder={'Введите пароль'}
                    name={'password'}
                    onChange={(e) => {
                        passwordRef.current = [
                            passwordRef.current[0],
                            e.target.value,
                        ]
                    }}
                />
                <Button
                    className="show-password"
                    variant="link"
                    onClick={() => togglePasswordVisibility(0)}
                >
                    {showPassword[0] ? (
                        <FaEye size={40} color="black" />
                    ) : (
                        <FaEyeSlash size={40} color="black" />
                    )}
                </Button>
            </InputGroup>
            <InputGroup className="input-control input-control-password">
                <label>Повторите пароль</label>
                <Form.Control
                    required={true}
                    type={showPassword[1] ? 'text' : 'password'}
                    placeholder={'Введите пароль'}
                    name={'password'}
                    onChange={(e) => {
                        passwordRef.current = [
                            e.target.value,
                            passwordRef.current[1],
                        ]
                    }}
                />
                <Button
                    className="show-password"
                    variant="link"
                    onClick={() => togglePasswordVisibility(1)}
                >
                    {showPassword[1] ? (
                        <FaEye size={40} color="black" />
                    ) : (
                        <FaEyeSlash size={40} color="black" />
                    )}
                </Button>
            </InputGroup>
            <div className={'actions'}>
                <InputGroup className={'remember-device'}>
                    <Form.Check
                        onChange={() => setChecked((state) => !state)}
                    />
                    <span>Запомнить устройство</span>
                </InputGroup>
                <Link href={'/recovery'}>Забыли пароль</Link>
            </div>
            <ReCAPTCHA
                size="normal"
                sitekey={SITE_KEY_RECAPTCHA}
                onChange={(token) => setRecaptchaToken(token)} 
                onErrored={() => setRecaptchaToken(null)} 
                onExpired={() => setRecaptchaToken(null)}
                ref={recaptchaRef}
            />
            <button type={'submit'}>{textButton}</button>
        </Form>
    )
}
